export default function isValidURL(url: string): boolean {
    try {
        new URL(url);
        return url.startsWith('http://') || url.startsWith('https://');
    } catch (error) {
        return false;
    }
}
